import type { Filter, MailboxFilter } from 'features/messaging/model/types'
import type { BottomItem, LeftMenuType } from 'redux/reducers/leftSideMenu'

import clsx from 'clsx'
import { $filter, $mailboxFilter, $search } from 'features/messaging/hooks/useFilters'
import { resetConversationCursors } from 'features/messaging/model/stores'
import { CHIP_FILTERS } from 'features/messaging/ui/const'
import { Link } from 'react-router-dom'

import css from '../LeftSideMenu.module.scss'

interface MessagingMenuProps {
	filter: Filter
	leftSide: {
		bottomList: BottomItem[]
		label?: string
		list?: any[]
		type: LeftMenuType
	}
	mailboxFilter: MailboxFilter
	searchDraft: string
}

export function MessagingMenu({
	filter,
	leftSide,
	mailboxFilter,
	searchDraft
}: MessagingMenuProps) {
	if (!leftSide.bottomList?.length || searchDraft !== '') return null

	return (
		<>
			<ul className="list">
				{leftSide.bottomList.map(item => (
					<li
						className={`text-list ${filter === item.key ? 'active semi-bold' : ''}`}
						key={item.id}
						onClick={() => {
							const nextFilter = (item.key ?? '') as '' | Filter
							$filter.set(nextFilter)
							$mailboxFilter.set('')
							$search.set('')
							resetConversationCursors()
						}}
					>
						<Link className="text-list" to={item.link}>
							<div className="line-list__img-container">
								<img alt="pageIcon" src={item.image} />
							</div>
							{item.title}
						</Link>
					</li>
				))}
			</ul>

			{filter !== 'archive' && filter !== 'spam' && (
				<div className={css.chipButtonsContainer}>
					<div className={css.chipButtonsGrid}>
						{CHIP_FILTERS.map(({ key, title }) => (
							<button
								className={clsx(css.chipButton, mailboxFilter === key && css.chipButtonActive)}
								key={key}
								onClick={() => {
									const next = mailboxFilter === key ? '' : key
									$mailboxFilter.set(next)
									$search.set('')
									resetConversationCursors()
								}}
							>
								{title}
							</button>
						))}
					</div>
				</div>
			)}
		</>
	)
}
